import React,{Fragment} from "react";
import { withStyles } from "@material-ui/core";
import DataGrid from '@dataGrid';
import styles from "../../styles";
import GridConfig from "./gridConfig";
import { getDataWithQueryString, postData} from "../../../../../api/componentAPIs";
import { compose } from "recompose";
import { withSnackbar } from 'notistack';
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import MESSAGES from "../../../../../appMessages";

class RouteEquipmentPreference extends React.PureComponent{
    constructor(props){
        super(props);
        this.state ={
            equipmentMappingData: null,
            errorMessage: null,
        }
        this._isMounted = false;
        this.gridConfig = new GridConfig();
        this.gridApi = null;
    }

    componentDidMount(){
        this._isMounted = true;
        this.getRouteEquipmentPreferenceData();
    }

    componentDidUpdate(prevProps){
        if(this.props.userData.userProfile.terminal.id !== prevProps.userData.userProfile.terminal.id){
            this.getRouteEquipmentPreferenceData();
        }       
    }

    componentWillUnmount(){
        this._isMounted = false;
    }

    getRouteEquipmentPreferenceData = () => {
        const terminalID = this.props.userData.userProfile.terminal.id;
        getDataWithQueryString('GetRouteEquipmentPreference', `terminalId=${terminalID}`).then(response => {            
            if(response.status === 200){
                if(this._isMounted){
                    this.setState({
                        equipmentMappingData: response.data,
                        errorMessage: null
                    });
                }                    
            } else { 
               this.handleDataFetchFailure();
            }       
        }, error => {
            this.handleDataFetchFailure();     
        });
    }

    handleDataFetchFailure = () => {
        if(this._isMounted){
            this.setState({
                equipmentMappingData: null,
                errorMessage: MESSAGES.EQUIPMENT_MAPPING.FETCH_DATA_FAILURE
            });
        }        
    }

    updateRouteEquipmentPreference = ({trailerId, params}) => {
        const requestObj = {
            terminalId: this.props.userData.userProfile.terminal.id,
            routeName: params.data.routeName,
            trailerId
        }
        postData('UpdateRouteEquipmentPreference', requestObj).then(response => {
           if(Math.trunc(response.status/100) === 2){
                const message =  MESSAGES.EQUIPMENT_MAPPING.UPDATE_SUCCESS;
                this.props.enqueueSnackbar(message, {variant: "success"});
                this._isMounted && this.getRouteEquipmentPreferenceData();
                return;
           }
           this.handleUpdateFailure(params, response.status);
        }, () => {
            this.handleUpdateFailure(params);
        });
    }

    handleUpdateFailure = (params, statusCode) => {
        params && this.restoreOldValue(params);
        if (statusCode === 403) {
            return;
        }        
        this.props.enqueueSnackbar(MESSAGES.EQUIPMENT_MAPPING.UPDATE_FAILURE, {variant: "error"});        
    }

    onGridReady = ({api}) => {
        this.gridApi = api;
    }

    onCellValueChanged = (params) => {
        if(params.colDef.field === "trailerName" ){
            this.handleTrailerTypeChange(params);
        }
    }

    handleTrailerTypeChange = (params) => {
        const { value: newTrailerId, label: newTrailerType } = params.newValue || {value: null , label: null};
        if(params.data.trailerId !== newTrailerId){
            params.data[params.colDef.field] = newTrailerType;
            this.updateRouteEquipmentPreference({
                trailerId: newTrailerId,
                params
            });
        } else {
            this.restoreOldValue(params)
        }
    }

    restoreOldValue = (params) => {
        if(params){
            params.data[params.colDef.field] = params.oldValue;
            this.gridApi.refreshCells({columns:[params.colDef.field],force: true});
        }       
    }


    render(){
        const { classes } = this.props;
        const { equipmentMappingData , errorMessage  } = this.state;
        return (
            <Fragment>
                <header className={classes.moduleHeader}  data-automationid="routeEquipment-title"> Route - Equipment Mapping </header>
                <div className={classes.moduleContainer}>
                    <div className={classes.moduleMessage}>
                        Each route can be assigned a default equipment type and system will honor it in the daily plan.
                    </div>
                    <div className={`${classes.gridContainer} ${classes.routeEquipmentMappingGridContainer}`}>
                        <div className={`${classes.dataGrid} ${classes.routeEquipmentMappingGrid}`}>
                           {!errorMessage ? (
                            <DataGrid
                                defaultColDef={this.gridConfig.config.defaultColDef}
                                columnDefs={this.gridConfig.config.columns}
                                config={this.gridConfig.config}
                                rowData={equipmentMappingData}
                                onGridReady={this.onGridReady}
                                onCellValueChanged={this.onCellValueChanged}
                                suppressHorizontalScroll={true}
                                deltaRowDataMode={true} 
                                getRowId={(params) => params.data.routeName}
                            />
                               ): (
                                <div className={classes.errorMessageContainer}>
                                        <div className={classes.errorMessage}> {errorMessage} </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default compose(withStyles(styles), withUserProfile, withSnackbar)(RouteEquipmentPreference);